import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import { errorStyles, selectFilterMenuStyle, selectFilterPaperStyle, titleFilterStyle } from '../Filter.style';
import { DatesSelector, TypeTemporality } from '../../DatesSelector';
import dayjs from 'dayjs';
import { DATES_CONSTANTS } from './constants';
const convertDate = (value) => {
    if (value instanceof Date)
        return dayjs(value);
    return value;
};
export const DatesPopover = ({ title, open, setAnchorEl, filterDates, setFilterDates, onSendDatesRange, anchorEl, dataQa, defaultValue, disableFuture, labelsDateFilter, maxDate, minDate, }) => {
    const [error, setError] = useState('');
    /*** Default temporality when opening the popover for dates */
    const defaultTemporality = () => {
        if (filterDates === null || filterDates === void 0 ? void 0 : filterDates.dateBefore)
            return TypeTemporality.BEFORE;
        else if (filterDates === null || filterDates === void 0 ? void 0 : filterDates.dateAfter)
            return TypeTemporality.AFTER;
        else if ((filterDates === null || filterDates === void 0 ? void 0 : filterDates.dateDebut) || (filterDates === null || filterDates === void 0 ? void 0 : filterDates.dateEnd))
            return TypeTemporality.BETWEEN;
        else if (defaultValue)
            return defaultValue;
        else
            return TypeTemporality.BEFORE;
    };
    const [dateTemporality, setDateTemporality] = useState(defaultTemporality);
    const handleErrors = (value) => {
        var _a, _b;
        const valueToTest = dayjs.isDayjs(value) ? value : dayjs(value);
        const valueToString = `${value}`;
        if (valueToString === 'Invalid Date') {
            return true;
        }
        if (disableFuture) {
            if (valueToTest.isAfter(dayjs())) {
                setError(((_a = labelsDateFilter === null || labelsDateFilter === void 0 ? void 0 : labelsDateFilter.errorMessages) === null || _a === void 0 ? void 0 : _a.isFuture) || DATES_CONSTANTS.defaultErrorMessages.isFuture);
                return true;
            }
        }
        if (minDate) {
            const min = dayjs.isDayjs(minDate) ? minDate : dayjs(minDate);
            if (valueToTest.isBefore(min)) {
                setError(((_b = labelsDateFilter === null || labelsDateFilter === void 0 ? void 0 : labelsDateFilter.errorMessages) === null || _b === void 0 ? void 0 : _b.isPastMinDate) || DATES_CONSTANTS.defaultErrorMessages.isPastMinDate);
                return true;
            }
        }
        return false;
    };
    const handleSendFilters = (filterDates) => {
        let invalidForm = false;
        const errors = [];
        const values = filterDates && Object.values(filterDates);
        values === null || values === void 0 ? void 0 : values.forEach((date) => {
            if (handleErrors(date))
                errors.push(date);
        });
        if (errors.length !== 0) {
            invalidForm = true;
        }
        if (dateTemporality === TypeTemporality.BETWEEN) {
            const dateDebut = (filterDates === null || filterDates === void 0 ? void 0 : filterDates.dateDebut) && convertDate(filterDates.dateDebut);
            const dateFin = (filterDates === null || filterDates === void 0 ? void 0 : filterDates.dateEnd) && convertDate(filterDates.dateEnd);
            const invalidDateRange = !dateDebut || !dateFin || (dateDebut && dateFin && dateDebut.diff(dateFin) < 0);
            if (!invalidDateRange) {
                setError((labelsDateFilter === null || labelsDateFilter === void 0 ? void 0 : labelsDateFilter.errorMessageRange) || DATES_CONSTANTS.defaultErrorMessages.range);
                invalidForm = true;
            }
        }
        if (invalidForm === false) {
            onSendDatesRange(filterDates);
            resetError();
        }
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const resetError = () => {
        setError('');
    };
    /*** ONCHANGE FOR ALL DATE PICKERS OF DATESELECTOR */
    const handleChangeSingleDate = (isDateBefore, value) => {
        if (value) {
            if (isDateBefore) {
                setFilterDates(Object.assign(Object.assign({}, filterDates), { dateBefore: dayjs(value).toDate() }));
                handleSendFilters(Object.assign(Object.assign({}, filterDates), { dateBefore: dayjs(value).toDate() }));
            }
            else {
                setFilterDates(Object.assign(Object.assign({}, filterDates), { dateAfter: dayjs(value).toDate() }));
                handleSendFilters(Object.assign(Object.assign({}, filterDates), { dateAfter: dayjs(value).toDate() }));
            }
        }
    };
    const handleChangeRangeDateDebut = (value) => {
        if (value) {
            setFilterDates(Object.assign(Object.assign({}, filterDates), { dateDebut: dayjs(value).toDate() }));
            handleSendFilters(Object.assign(Object.assign({}, filterDates), { dateDebut: dayjs(value).toDate() }));
        }
    };
    const handleChangeRangeDateEnd = (value) => {
        if (value) {
            setFilterDates(Object.assign(Object.assign({}, filterDates), { dateEnd: dayjs(value).toDate() }));
            handleSendFilters(Object.assign(Object.assign({}, filterDates), { dateEnd: dayjs(value).toDate() }));
        }
    };
    const handleReset = () => {
        handleSendFilters(filterDates);
        setFilterDates(undefined);
    };
    useEffect(() => {
        resetError();
    }, [dateTemporality]);
    return (React.createElement(Popover, { "data-qa": `${dataQa}-select`, sx: selectFilterMenuStyle, id: "popoverFilterDates", open: open, onClose: handleClose, anchorEl: anchorEl, PaperProps: {
            sx: Object.assign(Object.assign({}, selectFilterPaperStyle), { width: '248px' }),
        } },
        React.createElement(Box, { sx: titleFilterStyle },
            React.createElement("h3", null, title)),
        React.createElement(DatesSelector, { dataQa: `${dataQa}-datesSelector`, datesRange: filterDates, defaultValue: defaultValue, disableFuture: disableFuture, maxDate: maxDate, minDate: minDate, labelsDateFilter: labelsDateFilter, dateTemporality: dateTemporality, setDateTemporality: setDateTemporality, onChangeSingleDate: handleChangeSingleDate, onChangeRangeDateDebut: handleChangeRangeDateDebut, onChangeRangeDateEnd: handleChangeRangeDateEnd, onReset: handleReset }),
        error && (React.createElement(Box, { "data-qa": `${dataQa}-errorMessage`, sx: errorStyles },
            React.createElement(Typography, null, error)))));
};
